<rt-icon
  #booleanInfoDropdownTrigger="rtOverlayOrigin"
  [rtTooltip]="'app.new_search_page.boolean_search_info.tooltip' | translate"
  [rtTooltipMaxWidth]="274"
  [rtTooltipEnabled]="isFocus"
  [rtTooltipHasTextAlignCenter]="true"
  [size]="'small-x'"
  [name]="isFocus ? 'help-outline' : 'search'"
  [class.clickable]="isFocus"
  (click)="isFocus && toggleDropdown()"
  class="search-icon"
  rt-overlay-origin
  tabindex="0"
>
</rt-icon>

<div [class.focused]="isFocus" class="input-wrapper" #inputWrapperEl>
  @if (!platform.IS_MS) {
    <div
      #inputEl
      [rtHighlight]="value"
      [rtHighlightExpression]="highlight"
      (focus)="
        this.view !== ViewType.AuditLogs && analytics.track('[Candidates] FilterBy_InputClick');
        setFocusStatus(true)
      "
      (blur)="setFocusStatus(false, $event)"
      (valueChange)="emitValueChange($event)"
      class="input-inner"
    ></div>
  }
  @if (!(value && value.length)) {
    <div class="placeholder">
      {{ placeholder | translate }}
    </div>
  }
</div>

@if (platform.IS_MS) {
  <rt-input
    variant="rounded"
    [value]="value"
    [placeholder]="placeholder | translate"
    (focus)="
      this.view !== ViewType.AuditLogs && analytics.track('[Candidates] FilterBy_InputClick')
    "
    (valueChange)="emitValueChange($event)"
  ></rt-input>
}

<div class="actions">
  @if (value) {
    <rt-icon-button
      (click)="valueChange.emit(undefined)"
      variant="plain"
      iconName="close"
      iconColor="colorIconStrongDefault"
      shape="square"
    >
    </rt-icon-button>
  }
</div>

<ng-template
  #booleanInfoDropdown="rtConnectedOverlay"
  [width]="545"
  [open]="dropdownOpened"
  [origin]="booleanInfoDropdownTrigger"
  (backdropClick)="toggleDropdown(); setFocusStatus(false)"
  hasBackdrop
  rt-connected-overlay
>
  <rt-search-page-query-input-info
    [fields]="infoFields"
    [readMoreLink]="readMoreLink"
  ></rt-search-page-query-input-info>
</ng-template>
